import React from 'react'
import {Button} from 'react-weui'
import {isIos} from '../../../utils'
import '../../../css/page/InviteNewUserPage.css'
import Book1 from '../../../images/activity/inviteNew/all.png'


class InviteNewSuccessPage extends React.Component {
    constructor(props) {
        super(props)
        this.downloadApp = this.downloadApp.bind(this)
    }

    downloadApp() {
        window.location = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.lizhiweike'
    }

    render() {
        return <div className="invite-success-page">
            <div className="invite-success-header">
                <p className="invite-success-header__title">恭喜你！</p>
                <p className="invite-success-header__title">免费获得一节畅销书解读课</p>
                <p className="invite-success-header__tips">已放入你当前访问的账号</p>
                <img className="invite-success-header__book" src={Book1}/>
                <Button className="invite-download-btn" onClick={this.downloadApp}>下载APP听课</Button>
            </div>

            <div className="invite-success-tips">
                <div className="invite-success-tips__header">
                    <span className="invite-accepted-header__line"/>
                    <span className="invite-accepted-header__text">活动提示</span>
                    <span className="invite-accepted-header__line"/>
                </div>
                <div className="invite-success-tips__content">
                    <p className="invite-success-tips__text">1. 下载APP后，用你当前访问的账号登录APP，即可获得课程；</p>
                    <p className="invite-success-tips__text">2. 点击【我的微课】——【全部课程】即可看到赠送的畅销书解读课。</p>
                </div>
            </div>
        </div>
    }
}

export default InviteNewSuccessPage


// WEBPACK FOOTER //
// ./src/pages/AppPage/InviteNewUser/InviteNewSuccessPage.js